// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getPaymentStatusById } from 'app/constants/enums/PaymentStatus/main';

/* eslint-disable max-len */
export const EXTRA_PAY = getPaymentStatusById('extraPay');
export const EXTRA_PENALTY = getPaymentStatusById('extraPenalty');
export const NONE = getPaymentStatusById('none');
export const PAY = getPaymentStatusById('pay');
export const PENALTY = getPaymentStatusById('penalty');
/* eslint-enable max-len */
